module.exports = __webpack_public_path__ + "img/marker-point-amarillo.e822762c.png";